// SOURCE OF TRUTH: Dispatch.Platform.Models.NoteCategories.DefaultNoteCategories.Ids
// Keep in sync via parity tests in Dispatch.Database.
export const DEFAULT_NOTE_CATEGORIES = {
  General: 'c491910f-702e-4f96-8d13-f097a6280c5c',
  LockReason: '3b460a96-bb3a-4347-89d6-2d14f64724d3',
  AssignmentRequest: '9d478b3c-b3ef-4309-9841-be4a4c988d33',
  Cancellation: '316a6d89-be19-44d7-b4f6-2f82d6e6a37a',
  Reschedule: '5e1e1bc5-0b0c-4a80-9e40-01d21a2f7dea',
} as const;

export const DEFAULT_NOTE_CATEGORY_IDS = new Set<string>(
  Object.values(DEFAULT_NOTE_CATEGORIES)
);
